import { render, staticRenderFns } from "./MenuRecursiveHelper.vue?vue&type=template&id=a465cb6e&"
import script from "./MenuRecursiveHelper.vue?vue&type=script&lang=js&"
export * from "./MenuRecursiveHelper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports